import { Box, FormControlLabel, FormGroup, Grid, Switch } from "@mui/material";

const Switches = ({label}) => {
	return (
		<Box>
			<Grid container>
				<Grid item>
					<Switch {...label} defaultChecked/>
					<Switch {...label} />
					<Switch {...label} disabled defaultChecked/>
					<Switch {...label} disabled/>
				</Grid>
				<Grid item>
					<Switch {...label} defaultChecked size="small"/>
					<Switch {...label} defaultChecked size="medium"/>
					<Switch {...label} defaultChecked size="large"/>
					<Switch {...label} defaultChecked color="secondary"/>
					<Switch {...label} defaultChecked color="warning"/>
					<Switch {...label} defaultChecked color="default"/>
				</Grid>
				<Grid item>
					<FormGroup>
						<FormControlLabel control={<Switch defaultChecked/>} label="Label"/>
						<FormControlLabel required control={<Switch/>} label="Required"/>
						<FormControlLabel disabled control={<Switch/>} label="Disabled"/>
					</FormGroup>
				</Grid>
			</Grid>
		</Box>
	)
}

export default Switches;